import { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import DropdownFilter from "./DropdownFilter";
import TooltipBox from "./Tooltip";
import Tag from "./Tag";
import InputIconSearchPanelMultiSelection from "./InputIconSearchPanelMultiSelection";
import moment from "moment";
import { formatValueUnit } from "../js/utils";
import { formatCurrency } from "../support-extra/utils/utils";
import { rightStyle, sortFunction } from "../js/tableColumns";
import "../css/ProductTraceabilityList.css";
import { useOptics } from "../hooks/useOptics";

export default function ProductTraceabilityList(props) {
  const opticalList = useOptics();
  const [elementsFiltered, setElementsFiltered] = useState([]);
  const [selectedMovementTypes, setSelectedMovementTypes] = useState([]);
  const [selectedSourceOpticalList, setSelectedSourceOpticalList] = useState(
    [],
  );
  const [selectedDestinationOpticalList, setSelectedDestinationOpticalList] =
    useState([]);

  // console.log("elementsFiltered: ", elementsFiltered);
  // console.log("selectedSourceOpticalList: ", selectedSourceOpticalList);
  // console.log(
    // "selectedDestinationOpticalList: ",
    // selectedDestinationOpticalList,
  // );

  const columns = [
    {
      name: "Tipo movimiento",
      selector: (row) => row.tipoMovimiento,
      sortable: true,
      width: "17%",
    },
    {
      name: "Fecha/Hora",
      selector: (row) => moment(row.fechaHora).format("DD/MM/YYYY HH:mm:ss"),
      sortable: true,
      width: "10%",
    },
    {
      name: "Cantidad",
      selector: (row) => formatValueUnit(row.cantidad),
      sortable: true,
      width: "8%",
      style: rightStyle,
      sortFunction: (rowA, rowB) => sortFunction(rowA.cantidad, rowB.cantidad),
    },
    {
      name: "Paciente",
      selector: (row) => row.codigoCliente,
      sortable: true,
      width: "10%",
    },
    {
      name: "Óptica Origen",
      selector: (row) => row.opticaOrigen,
      sortable: true,
      width: "15%",
    },
    {
      name: "Óptica Destino",
      selector: (row) => row.opticaDestino,
      sortable: true,
      width: "15%",
    },
    {
      name: "Motivo",
      selector: (row) => row.motivo,
      sortable: true,
      width: "auto",
    },
    {
      name: "",
      sortable: false,
      width: "50px",
      cell: (row) =>
        row.tipoMovimiento !== "AJUSTE" &&
        row.tipoMovimiento !== "TRASPASO" && (
          <div
            onClick={() => {
              if (
                row.tipoMovimiento === "VENTA" ||
                row.tipoMovimiento === "DEVOLUCIÓN"
              ) {
                window.open(`/venta/${row.idVenta}`, "_blank");
              } else if (row.tipoMovimiento === "COMPRA") {
                window.open(`/almacen-albaran/${row.idAlbaran}`, "_blank");
              } else {
                alert("Acción por definir.");
              }
            }}
          >
            <img
              data-tooltip-id={String(row.id)}
              src={`/images/eye-orange.svg`}
              className="icon-pref"
              alt="icon"
            ></img>
            {row.tipoMovimiento === "COMPRA" && (
              <TooltipBox
                id={String(row.id)}
                content={
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 3,
                    }}
                  >
                    <div className="cell cell-start-content">
                      Nº albarán: {row.numeroAlbaran}
                    </div>
                    <div className="cell cell-start-content">
                      Fecha albarán:{" "}
                      {moment(row.fechaAlbaran).format("DD/MM/YYYY")}
                    </div>
                    <div className="cell cell-start-content">
                      PCB: {formatCurrency(row.pcb)}
                    </div>
                    <div className="cell cell-start-content">
                      DTO: {row.descuento}%
                    </div>
                    <div className="cell cell-start-content">
                      PCN: {formatCurrency(row.pcn)}
                    </div>
                  </div>
                }
              ></TooltipBox>
            )}
            {(row.tipoMovimiento === "VENTA" ||
              row.tipoMovimiento === "DEVOLUCIÓN") && (
              <TooltipBox
                id={String(row.id)}
                content={
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 3,
                    }}
                  >
                    <div className="cell cell-start-content">
                      Nº Operación: {row.nOperacion}
                    </div>
                    <div className="cell cell-start-content">
                      {row.tipoMovimiento === "DEVOLUCIÓN"
                        ? "Fecha Devolución"
                        : "Fecha Venta"}
                      : {moment(row.fechaHora).format("DD/MM/YYYY HH:mm:ss")}
                    </div>
                    <div className="cell cell-start-content">
                      PVP: {formatCurrency(row.pvp)}
                    </div>
                    <div className="cell cell-start-content">
                      DTO: {row.descuento}%
                    </div>
                    <div className="cell cell-start-content">
                      IVA: {row.iva}%
                    </div>
                  </div>
                }
              ></TooltipBox>
            )}
          </div>
        ),
    },
  ];

  const resetFilters = () => {
    setSelectedMovementTypes([]);
    setSelectedSourceOpticalList([]);
    setSelectedDestinationOpticalList([]);
  };

  useEffect(() => {
    setElementsFiltered(props.traceabilityList);
  }, [props]);

  function filterElements() {
    const filtered = props.traceabilityList.filter((e) => {
      if (
        selectedMovementTypes.length > 0 &&
        !selectedMovementTypes.includes(e.tipoMovimiento)
      )
        return false;
      if (
        selectedSourceOpticalList.length > 0 &&
        !selectedSourceOpticalList.includes(e.opticaOrigen)
      )
        return false;
      if (
        selectedDestinationOpticalList.length > 0 &&
        !selectedDestinationOpticalList.includes(e.opticaDestino)
      )
        return false;
      return true;
    });
    setElementsFiltered(filtered);
  }

  useEffect(() => {
    filterElements();
  }, [
    selectedMovementTypes,
    selectedSourceOpticalList,
    selectedDestinationOpticalList,
  ]);

  return (
    <div className="container-panel product-traceability-container">
      <div className="opt-table-title">
        Trazabilidad de producto ({elementsFiltered.length})
      </div>
      {props.traceabilityList.length > 0 && (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div className="product-traceability-filter-container">
            <DropdownFilter
              disabled={false}
              selectedOptions={selectedMovementTypes}
              optionList={[
                {
                  id: "COMPRA",
                  text: "COMPRA",
                  active: selectedMovementTypes.includes("COMPRA"),
                },
                {
                  id: "VENTA",
                  text: "VENTA",
                  active: selectedMovementTypes.includes("VENTA"),
                },
                {
                  id: "DEVOLUCIÓN",
                  text: "DEVOLUCIÓN",
                  active: selectedMovementTypes.includes("DEVOLUCIÓN"),
                },
                {
                  id: "TRASPASO",
                  text: "TRASPASO",
                  active: selectedMovementTypes.includes("TRASPASO"),
                },
                {
                  id: "AJUSTE",
                  text: "AJUSTE",
                  active: selectedMovementTypes.includes("AJUSTE"),
                },
              ]}
              op={"Tipo de movimiento"}
              onChange={(e) => {
                const list = selectedMovementTypes.includes(e.id)
                  ? selectedMovementTypes.filter((p) => p !== e.id)
                  : [...selectedMovementTypes, e.id];
                setSelectedMovementTypes(list);
              }}
            ></DropdownFilter>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <div className="data-field">
                <span className="label">Ópticas origen</span>
                <InputIconSearchPanelMultiSelection
                  size={2}
                  type={"type-alphanum-ext"}
                  options={opticalList.map((e) => e.text)}
                  selectedOptions={selectedSourceOpticalList}
                  onChange={(e) => {
                    setSelectedSourceOpticalList(e);
                  }}
                ></InputIconSearchPanelMultiSelection>
              </div>
              {selectedSourceOpticalList.length > 0 && (
                <span style={{ fontWeight: "500", fontSize: 13 }}>
                  Ópticas seleccionadas: {selectedSourceOpticalList.length}
                </span>
              )}
              <div className="tag-content">
                {selectedSourceOpticalList.map((e, i) => {
                  return (
                    <Tag
                      text={e}
                      key={i}
                      tagId={i}
                      onClick={(e) => {
                        setSelectedSourceOpticalList((prev) =>
                          prev.filter((element) => element !== e),
                        );
                      }}
                    ></Tag>
                  );
                })}
              </div>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <div className="data-field">
                <span className="label">Ópticas destino</span>
                <InputIconSearchPanelMultiSelection
                  size={2}
                  type={"type-alphanum-ext"}
                  options={opticalList.map((e) => e.text)}
                  selectedOptions={selectedDestinationOpticalList}
                  onChange={(e) => {
                    setSelectedDestinationOpticalList(e);
                  }}
                ></InputIconSearchPanelMultiSelection>
              </div>
              {selectedDestinationOpticalList.length > 0 && (
                <span style={{ fontWeight: "500", fontSize: 13 }}>
                  Ópticas seleccionadas: {selectedDestinationOpticalList.length}
                </span>
              )}
              <div className="tag-content">
                {selectedDestinationOpticalList.map((e, i) => {
                  return (
                    <Tag
                      text={e}
                      key={i}
                      tagId={i}
                      onClick={(e) => {
                        setSelectedDestinationOpticalList((prev) =>
                          prev.filter((element) => element !== e),
                        );
                      }}
                    ></Tag>
                  );
                })}
              </div>
            </div>
            <div className="dashboard-section-title">
              <button
                className="cell-label"
                style={{ width: "120px" }}
                tabIndex={-1}
                onClick={resetFilters}
              >
                Limpiar filtros
              </button>
            </div>
          </div>
          <DataTable
            columns={columns}
            data={elementsFiltered}
            className="custom-datatable"
            noDataComponent="No hay datos disponibles."
          />
        </div>
      )}
    </div>
  );
}
